import { api } from "./_client";

export async function listContacts() {
    const { data } = await api.get("/contacts");
    return data;
}

export async function createContact(payload) {
    const { data } = await api.post("/contacts", payload);
    return data;
}

export async function updateContact(id, payload) {
    const { data } = await api.patch(`/contacts/${id}`, payload);
    return data;
}

export async function deleteContact(id) {
    const { data } = await api.delete(`/contacts/${id}`);
    return data;
}

export async function listContactProjects(id) {
    const { data } = await api.get(`/contacts/${id}/projects`);
    return data;
}

// iter-184 — Create a lead from a contact (mirror action).
export async function createLeadFromContact(contactId) {
    const { data } = await api.post(`/contacts/${contactId}/create-lead`);
    return data; // { lead, created }
}

// iter-185 — Duplicate detection + merge
export async function findContactDuplicates() {
    const { data } = await api.get("/contacts/duplicates");
    return data.groups || [];
}

export async function mergeContacts(primaryId, mergeIds, fields = {}) {
    const { data } = await api.post(`/contacts/${primaryId}/merge`, {
        merge_ids: mergeIds,
        fields,
    });
    return data;
}

// ----- Quote templates -----
